import { render, staticRenderFns } from "./quotations.vue?vue&type=template&id=22cda554&scoped=true"
import script from "./quotations.vue?vue&type=script&lang=js"
export * from "./quotations.vue?vue&type=script&lang=js"
import style0 from "./quotations.vue?vue&type=style&index=0&id=22cda554&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cda554",
  null
  
)

export default component.exports